import { z } from 'zod';

/**
 * Une erreur signalee par la PWA elle-meme (spec observation-usage) : sans ce canal,
 * un ecran blanc chez un testeur ne laisse AUCUNE trace nulle part.
 *
 * Les champs sont TRONQUES et non rejetes : un signalement qui echouerait parce que
 * l'erreur est grosse ferait perdre exactement les traces qu'on cherche. Seul un
 * message vide est refuse — il ne dirait rien.
 */
const champTronque = (max: number) =>
  z
    .string()
    .nullable()
    .default(null)
    .transform((valeur) => (valeur === null ? null : valeur.slice(0, max)));

export const signalementErreurSchema = z.object({
  message: z
    .string()
    .min(1)
    .transform((valeur) => valeur.slice(0, 500)),
  stack: champTronque(4000),
  ecran: champTronque(200),
  userAgent: champTronque(300),
});

export type SignalementErreur = z.infer<typeof signalementErreurSchema>;
